export const SiteDefs = {
  MAX_ASSETS: 30,
  MAX_SELECTED_ASSETS: 10,
};
